import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage02 from "../../../../../../assets/images/ActiveLearning/hint/img_02.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          自分が「こうしたい」「 考えたい」「
          解決したい」という想いが、「問い」を立てる材料になる。
          選んだテーマの内容とヒントを参考に、自分がこれから考えていきたいことを思いつく限り入力しよう。
        </p>
      </div>
      {question && (
        <div className={styles.themEntry}>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
      <img
        className={styles.hintImage}
        src={hintImage02}
        alt="「自分だったらこうしたい」を見つけるヒント"
      />
      <Card label={"TRY"} icon={<IconLive />} title={"グループワーク"}>
        ①同じテーマ同士でグループをつくろう。
        <br />
        ②選んだテーマに対して「こうしたい」と思ったこととその理由をを発表し合おう。
        <br />
        ③このテーマに対して他にどんな事ができそうかを考えてみよう。
      </Card>
    </div>
  );
};
export default Issue2Material;
